import {BASE_TRACK_API_URL, TRACK_PATH} from '@constants/config'
import {apiRequest} from '@helpers/query/apiRequest'
import {apiRequestWithAuth} from '@helpers/query/apiRequestWithAuth'
import {serialize} from '@helpers/query/serialize'
import {
	IBodyDashboardSettings,
	IDashboardInfo,
	IDashboardNews,
	IDashboardSession,
	IParamsTrackTablePage,
	ITrackTablePage,
	IVoyagesRealtime,
} from '@containers/dashboard/types'

// The dashboard data comes from legacy track (same origin, session cookie).
const URL_DASHBOARD = `${TRACK_PATH}/dashboard`

const toTrackTableParams = ({start, length, search}: IParamsTrackTablePage) => serialize({
	iDisplayStart: start,
	iDisplayLength: length,
	sSearch: search,
})

export const getDashboardInfoApi = (): Promise<IDashboardInfo> => {
	return apiRequest<IDashboardInfo>({
		url: `${URL_DASHBOARD}/info`,
		options: {method: 'GET'},
	})
}

export const getDashboardSessionsApi = (params: IParamsTrackTablePage): Promise<ITrackTablePage<IDashboardSession>> => {
	return apiRequest<ITrackTablePage<IDashboardSession>>({
		url: `${URL_DASHBOARD}/list_sessions?${toTrackTableParams(params)}`,
		options: {method: 'GET'},
	})
}

export const getDashboardNewsApi = (params: IParamsTrackTablePage): Promise<ITrackTablePage<IDashboardNews>> => {
	return apiRequest<ITrackTablePage<IDashboardNews>>({
		url: `${URL_DASHBOARD}/list_news?${toTrackTableParams(params)}`,
		options: {method: 'GET'},
	})
}

export const applyDashboardSettingsApi = (body: IBodyDashboardSettings) => {
	const form = new URLSearchParams()
	Object.entries(body).forEach(([key, value]) => {
		if (value !== undefined && value !== null) form.append(key, String(value))
	})
	return apiRequest({
		url: `${URL_DASHBOARD}/settings`,
		options: {
			method: 'POST',
			body: form,
			headers: {'content-type': 'application/x-www-form-urlencoded'},
		},
	})
}

export const getVoyagesRealtimeApi = (accountIds: string): Promise<IVoyagesRealtime[]> => {
	return apiRequestWithAuth<IVoyagesRealtime[]>({
		url: `${BASE_TRACK_API_URL}/v1/voyages/realtime-statistic?${serialize({accountIds})}`,
		options: {method: 'GET'},
		hasLogOutOnErrorAuth: false,
	})
}
